import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useInternalAdmin } from '@contexts/InternalAdminContext';
import Footer from 'components/footer/Footer';

export default function InternalLayout() {
  const { currentUser, isInternalAdmin, loading } = useInternalAdmin();
  const location = useLocation();

  // Show loading state
  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background-100 dark:bg-navy-900">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated (preserve internal query param)
  if (!currentUser) {
    const searchParams = new URLSearchParams(location.search);
    if (!searchParams.has('internal')) {
      searchParams.set('internal', 'true');
    }
    return <Navigate to={`/auth/sign-in/default?${searchParams.toString()}`} replace />;
  }

  // Show access denied if not internal admin
  if (!isInternalAdmin) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background-100 dark:bg-navy-900">
        <div className="text-center max-w-md px-6">
          <div className="text-6xl mb-4">403</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Access Denied
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            This area is restricted to internal administrators only.
          </p>
          <a
            href="/"
            className="inline-block px-6 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors"
          >
            Go to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100 dark:bg-navy-900">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white dark:bg-navy-800 shadow-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-3">
              <h1 className="text-xl font-bold text-gray-900 dark:text-white">
                Latte Internal
              </h1>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600 dark:text-gray-400">
                {currentUser.email}
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <div className="p-3">
        <Footer />
      </div>
    </div>
  );
}
